import { localeKg } from './kg'
import ru from 'air-datepicker/locale/ru'

export function adpLocaleFor(rawLocale) {
  const lng = (rawLocale && typeof rawLocale === 'object' && 'value' in rawLocale)
    ? rawLocale.value
    : String(rawLocale || '').toLowerCase()

  switch (lng) {
    case 'kg':
    case 'ky':
      return localeKg
    case 'ru':
      return ru
    default:
      return localeKg
  }
}
